import MainLayout from "../../layouts/main-layout/MainLayout";
import "./SettingsPage.scss";
import TitleBox from "../../ui/title-box/TitleBox";
import ToggleSwitch from "../../ui/toggle-switch/ToggleSwitch";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { socketActions } from "../../../store/socketSlice";

const SettingsPage = () => {
  const mapVisibility = useAppSelector((s) => s.game.mapVisibility);
  const dispatch = useAppDispatch();

  const togglePlotpoles = () =>
    dispatch(socketActions.sendMessage("togglePlotpoles"));
  const toggleSafes = () =>
    dispatch(socketActions.sendMessage("toggleShowSafes"));
  const toggleZeroedSafes = () =>
    dispatch(socketActions.sendMessage("toggleShowSafes0000"));
  const toggleVehicles = () =>
    dispatch(socketActions.sendMessage("toggleVehicles"));
  const toggleVeins = () => dispatch(socketActions.sendMessage("toggleVeins"));
  const toggleBackpacks = () =>
    dispatch(socketActions.sendMessage("toggleBackpacks"));
  const toggleDeadBodies = () =>
    dispatch(socketActions.sendMessage("toggleDeadBodies"));

  return (
    <MainLayout>
      <div className="settings-page">
        <TitleBox title="Settings" />
        <div className="settings-group">
          <div className="group-title">
            Map visibility settings
          </div>
          <div className="group-content">
            <div className="setting">
              <div className="title">Show plotpoles & no build areas</div>
              <ToggleSwitch
                isEnabled={mapVisibility.plotpoles}
                onClick={togglePlotpoles}
              />
            </div>
            <div className="setting">
              <div className="title">Show safes & lockboxes</div>
              <ToggleSwitch
                isEnabled={mapVisibility.safes}
                onClick={toggleSafes}
              />
            </div>
            <div className="setting">
              <div className="title">
                Show zeroed safes & lockboxes (0000 / Red00)
              </div>
              <ToggleSwitch
                isEnabled={mapVisibility.zeroedSafes}
                onClick={toggleZeroedSafes}
              />
            </div>
            <div className="setting">
              <div className="title">Show vehicles</div>
              <ToggleSwitch
                isEnabled={mapVisibility.vehicles}
                onClick={toggleVehicles}
              />
            </div>
            <div className="setting">
              <div className="title">Show ore veins</div>
              <ToggleSwitch
                isEnabled={mapVisibility.veins}
                onClick={toggleVeins}
              />
            </div>
            <div className="setting">
              <div className="title">Show backpacks & loot crates</div>
              <ToggleSwitch
                isEnabled={mapVisibility.backpacks}
                onClick={toggleBackpacks}
              />
            </div>
            <div className="setting">
              <div className="title">Show dead bodies</div>
              <ToggleSwitch
                isEnabled={mapVisibility.deadBodies}
                onClick={toggleDeadBodies}
              />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default SettingsPage;
